import React from "react";
import { Link } from "react-router-dom";

const Rti = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5> RTI Act, 2005</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <ol>
          <li>
          <Link to={"/rti/application-form"} className="text-decoration-none">Application Form</Link>
          </li><hr/>
          <li>
          <Link to={"/rti/fees"} className="text-decoration-none">Fees</Link>
          
          </li><hr/>
          <li>
          <Link to={"/rti/list-of-authorities"} className="text-decoration-none">List of Authorities</Link>
           
          </li><hr/>
          <li>
          <Link to={"/rti/rti-replies"} className="text-decoration-none">RTI Replies</Link>
          </li><hr/>
          <li>
          <Link to={"/rti/proactive-disclouser"} className="text-decoration-none">Proactive Disclouser</Link>
            
          </li><hr/>
        </ol>
      </div>
    </div>
  );
};

export default Rti;
